import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "container-fluid" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-3 col-sm-6" }
const _hoisted_11 = { class: "card o-hidden" }
const _hoisted_12 = { class: "bg-primary b-r-4 card-body" }
const _hoisted_13 = { class: "media static-top-widget" }
const _hoisted_14 = { class: "align-self-center text-center" }
const _hoisted_15 = { class: "media-body" }
const _hoisted_16 = { class: "mb-0 counter" }
const _hoisted_17 = { class: "col-md-3 col-sm-6" }
const _hoisted_18 = { class: "card o-hidden" }
const _hoisted_19 = { class: "bg-success b-r-4 card-body" }
const _hoisted_20 = { class: "media static-top-widget" }
const _hoisted_21 = { class: "align-self-center text-center" }
const _hoisted_22 = { class: "media-body" }
const _hoisted_23 = { class: "mb-0 counter" }
const _hoisted_24 = { class: "col-md-3 col-sm-6" }
const _hoisted_25 = { class: "card o-hidden" }
const _hoisted_26 = { class: "bg-info b-r-4 card-body" }
const _hoisted_27 = { class: "media static-top-widget" }
const _hoisted_28 = { class: "align-self-center text-center" }
const _hoisted_29 = { class: "media-body" }
const _hoisted_30 = { class: "mb-0 counter" }
const _hoisted_31 = { class: "col-md-3 col-sm-6" }
const _hoisted_32 = { class: "card o-hidden" }
const _hoisted_33 = { class: "bg-warning b-r-4 card-body" }
const _hoisted_34 = { class: "media static-top-widget" }
const _hoisted_35 = { class: "align-self-center text-center" }
const _hoisted_36 = { class: "media-body" }
const _hoisted_37 = { class: "mb-0 counter" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "card" }
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = {
  key: 0,
  class: "status-chart"
}
const _hoisted_43 = { class: "d-flex align-items-center" }
const _hoisted_44 = { class: "text-capitalize" }
const _hoisted_45 = { class: "d-flex align-items-center" }
const _hoisted_46 = { class: "badge badge-light me-2" }
const _hoisted_47 = { class: "text-muted" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "card" }
const _hoisted_50 = { class: "card-body" }
const _hoisted_51 = {
  key: 0,
  class: "priority-chart"
}
const _hoisted_52 = { class: "d-flex align-items-center" }
const _hoisted_53 = { class: "text-capitalize" }
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "badge badge-light me-2" }
const _hoisted_56 = { class: "text-muted" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-12" }
const _hoisted_59 = { class: "card" }
const _hoisted_60 = { class: "card-body" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = {
  class: "progress mb-3",
  style: {"height":"30px"}
}
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = { class: "text-success mb-0 me-3" }
const _hoisted_67 = { class: "text-muted" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-12" }
const _hoisted_70 = { class: "card" }
const _hoisted_71 = { class: "card-body" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-3 col-sm-6 mb-3" }
const _hoisted_74 = { class: "col-md-3 col-sm-6 mb-3" }
const _hoisted_75 = { class: "col-md-3 col-sm-6 mb-3" }
const _hoisted_76 = { class: "col-md-3 col-sm-6 mb-3" }

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toast-notification';
import { kytChainService } from '@/services/kytChainService';
import type { ChainSummaryResponse } from '@/types/kyt-chain';
import KytChainLoading from '@/components/kyt-chain/KytChainLoading.vue';
import KytChainEmptyState from '@/components/kyt-chain/KytChainEmptyState.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'dashboard',
  setup(__props) {

const router = useRouter();
const toast = useToast();

// Reactive data
const loading = ref(false);
const summary = ref<ChainSummaryResponse | null>(null);

// Methods
const fetchSummary = async () => {
    loading.value = true;
    try {
        const response = await kytChainService.getChainSummary();
        if (response.success) {
            summary.value = response.data;
        } else {
            toast.error(response.message || 'Failed to fetch summary');
        }
    } catch (error) {
        console.error('Error fetching summary:', error);
        toast.error('Error fetching dashboard data');
    } finally {
        loading.value = false;
    }
};

const refreshDashboard = () => {
    fetchSummary();
    toast.success('Dashboard refreshed');
};

const navigateToLogs = () => {
    router.push('/kyt-chain/logs');
};

const navigateToOpenLogs = () => {
    router.push('/kyt-chain/logs?status=open');
};

const navigateToHighPriority = () => {
    router.push('/kyt-chain/logs?priority=high');
};

const getStatusColor = (status: string): string => {
    switch (status.toLowerCase()) {
        case 'open': return '#ffc107';
        case 'partial': return '#17a2b8';
        case 'closed': return '#28a745';
        default: return '#6c757d';
    }
};

const getPriorityColor = (priority: string): string => {
    switch (priority.toLowerCase()) {
        case 'low': return '#6c757d';
        case 'medium': return '#17a2b8';
        case 'high': return '#ffc107';
        case 'critical': return '#dc3545';
        default: return '#6c757d';
    }
};

const getProgressBarClass = (percentage: number): string => {
    if (percentage < 30) return 'bg-danger';
    if (percentage < 70) return 'bg-warning';
    return 'bg-success';
};

const calculatePercentage = (count: number, total: number): number => {
    if (total === 0) return 0;
    return Math.round((count / total) * 100);
};

// Lifecycle
onMounted(() => {
    fetchSummary();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-6" }, [
            _createElementVNode("h3", null, "KYT Chain Dashboard")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ol", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("Home", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("li", { class: "breadcrumb-item active" }, "KYT Chain Dashboard", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (loading.value)
        ? (_openBlock(), _createBlock(KytChainLoading, {
            key: 0,
            message: "Loading dashboard data...",
            size: "lg",
            color: "primary"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_vue_feather, {
                          type: "database",
                          class: "font-primary"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "m-0" }, "Total Logs", -1)),
                        _createElementVNode("h4", _hoisted_16, _toDisplayString(summary.value?.totals?.logs || 0), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_vue_feather, {
                          type: "list",
                          class: "font-success"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "m-0" }, "Total KYTs", -1)),
                        _createElementVNode("h4", _hoisted_23, _toDisplayString(summary.value?.totals?.kyts || 0), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_vue_feather, {
                          type: "layers",
                          class: "font-info"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "m-0" }, "Sub Categories", -1)),
                        _createElementVNode("h4", _hoisted_30, _toDisplayString(summary.value?.totals?.subCategories || 0), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_vue_feather, {
                          type: "briefcase",
                          class: "font-warning"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "m-0" }, "Assignments", -1)),
                        _createElementVNode("h4", _hoisted_37, _toDisplayString(summary.value?.totals?.assignments || 0), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Status Breakdown")
                  ], -1)),
                  _createElementVNode("div", _hoisted_41, [
                    (summary.value?.breakdowns?.status && summary.value.breakdowns.status.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.value.breakdowns.status, (status) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: status._id,
                              class: "status-item d-flex justify-content-between align-items-center mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", {
                                  class: "status-indicator me-3",
                                  style: _normalizeStyle({ backgroundColor: getStatusColor(status._id) })
                                }, null, 4),
                                _createElementVNode("span", _hoisted_44, _toDisplayString(status._id), 1)
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("span", _hoisted_46, _toDisplayString(status.count), 1),
                                _createElementVNode("small", _hoisted_47, _toDisplayString(calculatePercentage(status.count, summary.value?.totals?.logs || 0)) + "% ", 1)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock(KytChainEmptyState, {
                          key: 1,
                          icon: "pie-chart",
                          title: "No status data",
                          description: "Status breakdown will appear here when data is available",
                          "show-button": false
                        }))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Priority Breakdown")
                  ], -1)),
                  _createElementVNode("div", _hoisted_50, [
                    (summary.value?.breakdowns?.priority && summary.value.breakdowns.priority.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.value.breakdowns.priority, (priority) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: priority._id,
                              class: "priority-item d-flex justify-content-between align-items-center mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", {
                                  class: "priority-indicator me-3",
                                  style: _normalizeStyle({ backgroundColor: getPriorityColor(priority._id) })
                                }, null, 4),
                                _createElementVNode("span", _hoisted_53, _toDisplayString(priority._id), 1)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("span", _hoisted_55, _toDisplayString(priority.count), 1),
                                _createElementVNode("small", _hoisted_56, _toDisplayString(calculatePercentage(priority.count, summary.value?.totals?.logs || 0)) + "% ", 1)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock(KytChainEmptyState, {
                          key: 1,
                          icon: "bar-chart-2",
                          title: "No priority data",
                          description: "Priority breakdown will appear here when data is available",
                          "show-button": false
                        }))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Completion Overview")
                  ], -1)),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _cache[9] || (_cache[9] = _createElementVNode("h6", null, "Average Completion Rate", -1)),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["progress-bar", getProgressBarClass(summary.value?.completion?.averageCompletion || 0)]),
                            style: _normalizeStyle({ width: (summary.value?.completion?.averageCompletion || 0) + '%' })
                          }, _toDisplayString(summary.value?.completion?.averageCompletion || 0) + "% ", 7)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _cache[10] || (_cache[10] = _createElementVNode("h6", null, "Total Completed", -1)),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("h3", _hoisted_66, _toDisplayString(summary.value?.completion?.totalCompleted || 0), 1),
                          _createElementVNode("small", _hoisted_67, " out of " + _toDisplayString(summary.value?.totals?.logs || 0) + " total logs ", 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Quick Actions")
                  ], -1)),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("button", {
                          onClick: navigateToLogs,
                          class: "btn btn-primary btn-lg w-100"
                        }, [
                          _createVNode(_component_vue_feather, {
                            type: "database",
                            class: "me-2"
                          }),
                          _cache[12] || (_cache[12] = _createTextVNode(" View All Logs ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("button", {
                          onClick: navigateToOpenLogs,
                          class: "btn btn-warning btn-lg w-100"
                        }, [
                          _createVNode(_component_vue_feather, {
                            type: "clock",
                            class: "me-2"
                          }),
                          _cache[13] || (_cache[13] = _createTextVNode(" Open Logs ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("button", {
                          onClick: navigateToHighPriority,
                          class: "btn btn-danger btn-lg w-100"
                        }, [
                          _createVNode(_component_vue_feather, {
                            type: "alert-triangle",
                            class: "me-2"
                          }),
                          _cache[14] || (_cache[14] = _createTextVNode(" High Priority ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("button", {
                          onClick: refreshDashboard,
                          class: "btn btn-success btn-lg w-100"
                        }, [
                          _createVNode(_component_vue_feather, {
                            type: "refresh-cw",
                            class: "me-2"
                          }),
                          _cache[15] || (_cache[15] = _createTextVNode(" Refresh Data ", -1))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
    ])
  ], 64))
}
}

})